import { render, staticRenderFns } from "./Archives.vue?vue&type=template&id=3ac22734&scoped=true&"
import script from "./Archives.vue?vue&type=script&lang=js&"
export * from "./Archives.vue?vue&type=script&lang=js&"
import style0 from "./Archives.vue?vue&type=style&index=0&id=3ac22734&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac22734",
  null
  
)

export default component.exports